import { BlogLayout } from "@/components/Blog/BlogLayout";
import { Feedback } from "@/components/Feedback";
import { SOCIAL_URLS } from "@/constants";
import { getCurrentUrl } from "@/utils/getCurrentUrl";
import { Box, Group, List, Text, Title } from "@mantine/core";
import {
  IconBrandDiscord,
  IconBrandSteam,
  IconBrandTwitch,
  IconBrandVk,
} from "@tabler/icons-react";
import { InferGetStaticPropsType } from "next";
import { NextSeo } from "next-seo";
import Image from "next/image";
import Link from "next/link";
import css from "./contacts.module.css";
import { getStaticProps } from "./index";

export default function AboutPage({}: InferGetStaticPropsType<
  typeof getStaticProps
>) {
  return (
    <>
      <NextSeo
        title="Wofm | Контакты"
        description="Вы можете перейти по этой ссылке и сразу отправить мне сообщение, а так же найти все остальные ссылки для связи со мной"
        openGraph={{ images: [{ url: `${getCurrentUrl()}/avatar.webp` }] }}
      />
      <BlogLayout
        fullWidth={true}
        sidebarMetaInfo={void 0}
        breadcrumb={{ href: "/contacts", title: "Контакты" }}
      >
        <Title order={1}>Контакты</Title>
        <div className={css.grid}>
          <Box pos="relative" m="auto">
            <Image
              src="/avatar.webp"
              alt="Мой портрет"
              width={480}
              className={css.image}
              height={640}
            />
          </Box>
          <Group>
            <Box>
              <Title order={2}>Где меня быстрее всего найти?</Title>
              <Text>
                Чаще всего я обитаю у себя на сервере в{" "}
                <Link
                  href={SOCIAL_URLS.DISCORD}
                  className={css.link}
                  prefetch={false}
                >
                  дискорде
                </Link>
                , там я тоже выкладываю некоторые свои работы и обсуждаю
                насущные темы
              </Text>
            </Box>
            <Box>
              <Title order={2}>Ссылки на все соцсети</Title>
              <List spacing="md" size="sm" center>
                <Link href={SOCIAL_URLS.VK} prefetch={false}>
                  <List.Item icon={<IconBrandVk />}>Вконтакте</List.Item>
                </Link>
                <Link href={SOCIAL_URLS.STEAM} prefetch={false}>
                  <List.Item icon={<IconBrandSteam />}>Steam</List.Item>
                </Link>
                <Link href={SOCIAL_URLS.DISCORD} prefetch={false}>
                  <List.Item icon={<IconBrandDiscord />}>Discord</List.Item>
                </Link>
                <Link href={SOCIAL_URLS.TWITCH} prefetch={false}>
                  <List.Item icon={<IconBrandTwitch />}>Twitch</List.Item>
                </Link>
              </List>
            </Box>

            <Box>
              <Title order={2}>Проблемы с сайтом?</Title>
              <Text>
                Если у вас что-то не открывается или вы нашли ошибку, отправьте
                письмо через форму обратной связи ниже с подробным описанием
                проблемы
              </Text>
            </Box>
          </Group>
        </div>
        <Feedback />
      </BlogLayout>
    </>
  );
}
